<template>
  <div class="table-wrapper">
    <table v-if="!isMobile">
      <tr>
        <th />
        <th
          v-for="(column, index) in header"
          :key="`th-${index}`"
          class="heading"
        >
          <div>{{ column }}</div>
          <div
            v-if="headerImagesClasses.length"
            :class="['card', headerImagesClasses[`${index}`]]"
          />
        </th>
      </tr>
      <template v-for="(item, itemIndex) in tableData">
        <tr :key="itemIndex">
          <td
            :colspan="header.length + 1"
            class="title-row"
          >
            <div class="table-title">{{ item.title }}</div>
            <div class="table-subtitle">{{ item.subTitle }}</div>
          </td>
        </tr>
        <tr
          v-for="(row, rowIndex) in item.rows"
          :key="`tr-${rowIndex}-${itemIndex}`"
          class="table-row"
        >
          <td class="cell">
            <div v-dompurify-html="row.rowTitle" />
            <a
              v-if="row.rowLink"
              href="javascript:void(0)"
              @click="openModal(row.rowLink)"
            >
              {{ row.rowLink.linkText }}
            </a>
          </td>
          <td
            v-for="(cell, cellIndex) in row.cells"
            :key="cellIndex"
            v-dompurify-html="cell"
            class="cell"
          />
        </tr>
      </template>
    </table>

    <div v-if="isMobile">
      <div
        v-for="(item, index) in header"
        :key="`d-${index}`"
      >
        <div class="heading">
          <div
            v-if="headerImagesClasses.length"
            :class="['card', headerImagesClasses[`${index}`]]"
          />
          <span>{{ item }}</span>
        </div>

        <div
          v-for="(tableItem, itemIndex) in tableData"
          :key="`td-${itemIndex}`"
        >
          <div class="title-row table-title">
            {{ tableItem.title }}
          </div>
          <div
            v-for="(row, rowIndex) in tableItem.rows"
            :key="`row-${rowIndex}`"
            class="table-row"
          >
            <div class="column">
              <div v-dompurify-html="row.rowTitle" />
              <a
                v-if="row.rowLink"
                href="javascript:void(0)"
                @click="openModal(row.rowLink)"
              >
                {{ row.rowLink.linkText }}
              </a>
            </div>
            <div
              v-dompurify-html="row.cells[`${index}`]"
              class="column"
            />
          </div>

          <div
            v-if="tableItem.subTitle"
            class="table-row table-subtitle"
          >
            {{ tableItem.subTitle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      header: {
        type: Array,
        default: () => []
      },
      tableData: {
        type: Array,
        default: () => []
      },
      headerImagesClasses: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      ...mapGetters('device', [
        'isMobile'
      ])
    },

    methods: {
      openModal (link) {
        this.$store.dispatch('main/openModal')
        this.$store.commit('main/setShowModalHeader', false)
        this.$store.commit('main/setShowModalHeaderWhite', true)
        this.$store.commit('main/setModalClass', 'without-body-margin')
        this.$store.commit('main/setModalTitle', link.popupTitle)
        this.$store.commit('main/setModalContent', link.popupContent)
        this.$store.commit('main/setModalType', 'centered')
        this.$store.commit('main/setModalCloseFn', this.closeModal)
      },

      closeModal () {
        this.$store.dispatch('main/closeModal')
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .table-wrapper {
    margin-bottom: 45px;

    ::v-deep a {
      color: $blue-medium;
      line-height: 24px;

      &:hover {

        @include bp-mf-tablet {
          color: $blue-light;
        }
      }
    }
  }

  table {
    width: 100%;

    tr:first-child {
      border-bottom: 1px solid $grey-border;
    }
  }

  .heading {
    margin: 40px 0 12px;
    font-weight: 500;
    font-size: em(20);
    text-align: center;

    span {
      vertical-align: middle;
    }

    @include bp-mf-tablet {
      width: 25%;
      padding: 47px 0 15px;
      font-size: em(16);
    }
  }

  .card {
    display: inline-block;
    width: 87px;
    height: 52px;
    margin: 4px auto 0;
    background-repeat: no-repeat;
    vertical-align: middle;

    @include bp-mf-tablet {
      width: 170px;
      height: 101px;
    }

    &.BASIC {
      background-image: url("~assets/images/pins/BASIC.png");
      background-size: contain;
    }

    &.EX {
      background-image: url("~assets/images/pins/EX.png");
      background-size: contain;
    }

    &.VIP {
      background-image: url("~assets/images/pins/VIP.png");
      background-size: contain;
    }
  }

  .title-row {
    height: 52px;
    line-height: 52px;
    background-color: $table-gray-background;
    text-align: center;

    @include bp-mf-tablet {
      padding: 5px 14px;
      line-height: inherit;
      text-align: left;
    }
  }

  .table-title {
    font-weight: 500;
    font-size: em(12);

    @include bp-mf-tablet {
      font-size: em(16);
    }
  }

  .table-subtitle {
    color: $grey;
    font-size: em(12);
    line-height: 20px;
  }

  .table-row {
    min-height: 42px;
    padding: 10px 0;
    border-bottom: 1px solid $grey-border;
  }

  .column {
    width: 49%;
    padding: 0 3px 0 0;
    display: inline-block;
    font-size: em(12);
    line-height: 20px;
  }

  .cell {
    padding: 6px 14px;
    height: 72px;
    font-size: 12px;

    &:not(:first-child) {
      text-align: center;
    }
  }

  ::v-deep .modal-main-part {
    padding-top: 22px;
  }

</style>
